import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  UPDATE_CRQ_RELATIONSHIPS_REQUEST,
  UPDATE_CRQ_RELATIONSHIPS_SUCCESS,
  UPDATE_CRQ_RELATIONSHIPS_ERROR,
} from './relationships-actions';

// DVB This reducer state is not used yet, but could be useful for
// making the progress bar better reflect the saving process
const defaultState = {
  savingRelationships: false,
};


// generate an action handler that sets savingApprovers value
// function accepts the value desired for savingApprovers
const setSavingRelationships = (savingRelationships) => (state, action) => ({
  ...state,
  savingRelationships,
});


const actionHandlers = {
  [UPDATE_CRQ_RELATIONSHIPS_REQUEST]: setSavingRelationships(true),
  [UPDATE_CRQ_RELATIONSHIPS_SUCCESS]: setSavingRelationships(false),
  [UPDATE_CRQ_RELATIONSHIPS_ERROR]: setSavingRelationships(false),
};

const relationshipsReducer = createReducer(defaultState, actionHandlers);

export {
  relationshipsReducer,
  defaultState,
};

